import { Button } from "../../../components/ui/button";

const MeetingFilters = ({ currentFilter, onFilterChange }) => {
  const filters = [
    { label: "All Meetings", value: "all" },
    { label: "Upcoming", value: "upcoming" },
    { label: "Today", value: "today" },
    { label: "Overdue", value: "overdue" },
    { label: "Completed", value: "completed" }
  ];

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {filters.map((filter) => (
        <Button
          key={filter.value}
          variant={currentFilter === filter.value ? "default" : "outline"}
          onClick={() => onFilterChange(filter.value)}
          size="sm"
          className="rounded-full px-4"
        >
          {filter.label}
        </Button>
      ))}
    </div>
  );
};

export default MeetingFilters;
